import { Swiper, SwiperSlide } from 'swiper/react';
import { Box, Button, Divider, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext, useRef, useState } from 'react';
import { CampaignContext } from '../../contexts/CampaignContext';
import usePlatformCardColors from '../../hooks/usePlatformCardColors';
import { getMediaLogo } from '../../utils/file';
import { ISmsPanelContent } from '../../interfaces/campaign';

type PreviewWebSiteAdProps = {
	smsContent: ISmsPanelContent | null;
	handleOpenPostModal: () => void;
	previewContent?: boolean;
};

const PreviewWebSiteAd: React.FC<PreviewWebSiteAdProps> = ({ smsContent, previewContent, handleOpenPostModal }) => {
	const swiperRef = useRef<any>(null);
	const { t } = useTranslation();
	const [activeIndex, setActiveIndex] = useState<number>(0);
	const { selectedContentType, selectedPlatform, selectedMediaTypeId } = useContext(CampaignContext);
	const { borderColorClass } = usePlatformCardColors(selectedPlatform!);
	const handleSlideChange = (swiper: any) => {
		setActiveIndex(swiper.activeIndex);
	};
	return (
		<>
			<Box className="relative flex gap-x-6 pt-10">
				<Box className={`flex w-full gap-5`}>
					{selectedMediaTypeId === 'push_notification' ? (
						<>
							{previewContent ? <div className="mx-2">{smsContent && smsContent?.images && <img src={smsContent.images[0]} alt={`Post`} className={`w h-64 object-cover`} />}</div> : smsContent && smsContent?.images && <div className={`relative`}>{smsContent.images[0].type.split('/')[0] === 'image' ? <img src={URL.createObjectURL(smsContent.images[0])} alt={`Post `} className={`h-64 w-full object-cover`} /> : <video src={URL.createObjectURL(smsContent.images[0])} className="h-64 w-full object-cover" controls />}</div>}
							<Button variant="text" className="absolute left-5 top-0 m-0 flex self-end px-0" onClick={handleOpenPostModal}>
								{t('edit')}
							</Button>

							<Box className="w-full">
								<TextField
									InputProps={{
										readOnly: true,
									}}
									fullWidth
									label={t('text_message')}
									variant="outlined"
									multiline
									rows={5}
									value={smsContent?.description}
								/>
								<div className="mt-5 flex flex-wrap justify-between">
									<TextField
										InputProps={{
											readOnly: true,
										}}
										size="medium"
										label={t('link')}
										fullWidth
										variant="outlined"
										value={smsContent?.link}
									/>
								</div>
							</Box>
						</>
					) : (
						<>
							<div className="flex flex-wrap gap-4">
								<Box className="w-[350px]">
									<Box className={`relative rounded-2xl border ${borderColorClass}`}>
										<Box className="flex items-center justify-between px-3 py-2">
											<Typography className="text-base font-medium text-grey-900">{selectedContentType ? t(selectedContentType) : t('post')}</Typography>
											<Divider className={`mx-2 grow border ${borderColorClass}`} />
											<img src={getMediaLogo(selectedPlatform!)} alt={`${t(selectedPlatform!)} logo`} className="mb-1 h-8 w-8" />
										</Box>
										<Divider className={`border-1 ${borderColorClass}`} />
										{smsContent && smsContent?.images && (
											<div className="relative">
												{
													<div className="absolute top-3 z-20 flex w-full justify-center gap-2 px-3">
														{Array(smsContent && smsContent?.images.length)
															.fill(2)
															.map((_, index) => (
																<span key={index} className={`h-1 w-full rounded-sm ${activeIndex === index ? 'bg-white' : 'bg-gray-400'}`}></span>
															))}
													</div>
												}
												{previewContent ? (
													<img src={smsContent?.images[0]} alt={`Post`} className={`h-64 w-full object-cover`} />
												) : (
													<Swiper ref={swiperRef} slidesPerView={1} pagination={true} className="mySwiper" onSlideChange={handleSlideChange}>
														{smsContent?.images?.map((media: any, index: string) => (
															<SwiperSlide key={index}>
																<div className={`relative`}>{media.type.split('/')[0] === 'image' ? <img src={URL.createObjectURL(media)} alt={`Post ${index + 1}`} className={`h-64 w-full object-cover`} /> : <video src={URL.createObjectURL(media)} className="h-64 w-full object-cover" controls />}</div>
															</SwiperSlide>
														))}
													</Swiper>
												)}
											</div>
										)}
										<img className="" src="/images/campaigns/telegram_menu.png" alt="" />
									</Box>
								</Box>
							</div>
							<Button variant="text" className="absolute left-5 top-0 m-0 flex self-end px-0" onClick={handleOpenPostModal}>
								{t('edit')}
							</Button>

							<Box className="w-full">
								<TextField
									InputProps={{
										readOnly: true,
									}}
									fullWidth
									label={t('text_message')}
									variant="outlined"
									multiline
									rows={5}
									value={smsContent?.description}
								/>
							</Box>
						</>
					)}
				</Box>
			</Box>
		</>
	);
};

export default PreviewWebSiteAd;
